import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from '@emotion/styled';
// Native Paraglide JS imports
import { course_section_title_required, course_section_title_label, course_section_title_placeholder, course_section_creating, course_section_create } from '@paraglide/messages';
// --- Styled Components (기존 폼 스타일 재사용 또는 유사하게 정의) ---
const FormContainer = styled.form`
  background-color: #fff;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 500px; // 폼 너비 조정
  margin: 20px auto;
`;
const FormGroup = styled.div`
  margin-bottom: 20px;
`;
const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 0.9rem;
`;
const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
`;
const SubmitButton = styled.button`
  background-color: #28a745; // 생성 버튼 색상 변경 (예: 녹색)
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #218838;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
const SectionCreateForm = ({ onSubmit, isLoading })=>{
    const [title, setTitle] = useState('');
    const handleChange = (e)=>{
        setTitle(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!title.trim()) {
            alert(course_section_title_required());
            return;
        }
        onSubmit({
            title
        });
    };
    return /*#__PURE__*/ _jsxs(FormContainer, {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ _jsxs(FormGroup, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        htmlFor: "sectionTitle",
                        children: course_section_title_label()
                    }),
                    /*#__PURE__*/ _jsx(Input, {
                        type: "text",
                        id: "sectionTitle",
                        name: "title" // 상태와 일치
                        ,
                        value: title,
                        onChange: handleChange,
                        placeholder: course_section_title_placeholder(),
                        required: true
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SubmitButton, {
                type: "submit",
                disabled: isLoading,
                children: isLoading ? course_section_creating() : course_section_create()
            })
        ]
    });
};
export default SectionCreateForm;
